import React, { useEffect, useState } from "react";

const AlertMessage = ({ variant = "success", message = "", duration = null, onClose }) => {
    const [show, setShow] = useState(true);

    useEffect(() => {
        let timer;
        if (duration) {
            timer = setTimeout(() => {
                setShow(false);
                if (onClose) onClose();
            }, duration);
        }
        return () => clearTimeout(timer);
    }, [duration, onClose]);

    if (!show) return null;

    const handleClose = () => {
        setShow(false);
        if (onClose) onClose();
    };

    return (
        <div
            className={`alert alert-${variant} alert-dismissible fade show position-fixed top-0 start-50 translate-middle-x mt-3`}
            role="alert"
            style={{ zIndex: 9999, minWidth: 600 }}
        >
            {message}
            <button
                type="button"
                className="btn-close"
                onClick={handleClose}
                aria-label="Close"
            ></button>
        </div>
    );
};

export default AlertMessage;
